import { render, staticRenderFns } from "./CoreSmartCaptcha.vue?vue&type=template&id=22148150&scoped=true&"
import script from "./CoreSmartCaptcha.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CoreSmartCaptcha.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./CoreSmartCaptcha.vue?vue&type=style&index=0&id=22148150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22148150",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22148150')) {
      api.createRecord('22148150', component.options)
    } else {
      api.reload('22148150', component.options)
    }
    module.hot.accept("./CoreSmartCaptcha.vue?vue&type=template&id=22148150&scoped=true&", function () {
      api.rerender('22148150', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/CoreSmartCaptcha/CoreSmartCaptcha.vue"
export default component.exports